export default __webpack_public_path__ + "static/media/photo-3@2x.37a29c05.png";